import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import Signals from '../../signals/Signals';

import AbstractCommand from '../AbstractCommand';
import userDraftDelete from '../../requests/drafts/userDraftDelete';

/**
 *
 */
export default class DeleteUserDraftCommand extends AbstractCommand {

	/**
	 *
	 * @param draftsStore DraftsStore
	 * @param userId Number
	 * @param draft Draft
	 * @param suppressMessage bool
	 */
	constructor(draftsStore, userId, draft, suppressMessage = false) {
		super();

		this.draftsStore = draftsStore;
		this.userId = userId;
		this.draft = draft;
		this.suppressMessage = suppressMessage;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return userDraftDelete(this.userId, this.draft.id).then((response) => {

			this.draftsStore.remove(this.draft);

			// Show message
			if(!this.suppressMessage) {
				Signals.ShowMessageDialog.dispatch(<FormattedHTMLMessage id="draft.deleted.message"
																		 values={{id: this.draft.id}}/>);
			}

			// Signal that Draft is deleted
			Signals.DraftDeleted.dispatch(this.draft);

			if(success) {
				success(response);
			}

		}).catch(err => {
			if(error) {
				error(err)
			}
		});
	}
}
